import moment from 'moment';

import { Link } from 'react-router-dom';
import { BsFillChatLeftDotsFill } from 'react-icons/bs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';

import Header from 'components/ui/Header';
import Chat from 'components/ui/Chat';
import { useAuth } from 'providers/auth';

import TicketApi from 'api/ticket';
import DataGridWithPagination from 'components/ui/DataGrid/DataGridWithPagination';
import AddChamadoPage from './AddChamadoPage';

export default function HelpPage() {
  const { t } = useTranslation();

  const history = useHistory();

  const { me } = useAuth();
  const [tickets, setTickets] = useState([]);
  const [current_page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const { path, url } = useRouteMatch();

  const backUrl = {
    pathname: url,
  };

  useEffect(() => {
    const fetchCards = async () => {
      setLoading(true);
      try {
        const data = await TicketApi.all(me.company.id);
        setTickets(data);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
  }, [me.company.id]);

  const formatDateTime = ({ row, column }) => {
    const value = row[column.key];

    if (!value) {
      return '--';
    }

    return moment(value).format('DD/MM/YYYY HH:mm');
  };

  const formatUser = ({ row, column }) => {
    return row[column.key]?.name || '--';
  };

  const formatStatus = ({ row }) => {
    return t(`status.${row.status.toLowerCase()}`).toUpperCase();
  };

  const onRowClick = row => {
    history.push(`/chamados/${row.id}`);
  };

  const columns = [
    { key: 'id_seq', name: 'ID', width: 'auto', sortable: true },
    { key: 'title', name: t('columns.title'), width: 'auto', sortable: true },
    { key: 'creator', name: 'Solicitante', width: 'auto', sortable: true, formatter: formatUser },
    { key: 'assignee', name: 'Responsável', width: 'auto', sortable: true, formatter: formatUser },
    { key: 'status', name: 'Status', width: 'auto', sortable: true, formatter: formatStatus },
    { key: 'created_at', name: t('columns.created_at'), width: 'auto', sortable: true, formatter: formatDateTime },
    { key: 'updated_at', name: t('columns.updated_at'), width: 'auto', sortable: true, formatter: formatDateTime },
  ];

  const rows = tickets;

  const handlePageChange = page => {
    setPage(page);
  };

  const showChat = () => {
    window.Tawk_API.toggle();
  };

  return (
    <>
      <Header>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h1 className="m-0 p-0 fw-lighter">Central de Ajuda</h1>
          </div>

          <div className="d-flex">
            <div>
              <a href="https://youfy.tawk.help/" rel="noreferrer" target="_blank" className="text-white btn btn-link me-3">
                Base de conhecimento
              </a>
            </div>

            <div>
              <button onClick={showChat} className="text-white btn btn-link me-3">
                Atendimento via Chat
              </button>
            </div>
            <Link className="btn btn-outline-light" to={`/help/add`}>
              Criar chamado
            </Link>
          </div>
        </div>
      </Header>

      <div className="container">
        <div className="rdg-row-clickable">
          <DataGridWithPagination
            grid={{ columns, rows }}
            pagination={{ current_page, count: tickets.length, onPageChange: handlePageChange, pageSize: 10 }}
            loading={loading}
            onRowClick={onRowClick}
          />
        </div>

        <button onClick={showChat} className="btn btn-fab">
          <BsFillChatLeftDotsFill size={22} />
        </button>

        <Switch>
          <Route exact path={`${path}/add`} children={<AddChamadoPage backUrl={backUrl} />} />
        </Switch>
      </div>
      <Chat />
    </>
  );
}
